import React from 'react'
import { Link } from 'gatsby'
import { Button, Box, Heading, Text } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  author: {
    display: `inline-block`,
    color: `alpha`
  },
  occupation: {
    mb: 4
  },
  specialty: {
    color: `text`,
    mb: 4
  }
}

export default () => (
  <>
    <Heading variant='h1'>
      The <Text sx={styles.author}><em>Newman Review</em></Text>
    </Heading>
    <Heading variant='h3' sx={styles.specialty}>
      An e-publication of the National Institute for Newman Studies (NINS) featuring scholarly, original articles on John Henry Newman’s legacy and its relevance for today.
    </Heading>
    <Box variant='buttons.group'>
      <Button as={Link} to='/about'>
        About
      </Button>
      <Button variant='white' as={Link} to='/contact'>
        Contact
      </Button>
    </Box>
  </>
)
